const LEGACY_PASSWORD_ERROR_MESSAGES: Record<string, string> = {
  'Institution owner access required.':
    'Esta ação é permitida apenas para o dono da instituição.',
  'Current password is incorrect': 'Senha atual incorreta.',
  'Password updated successfully': 'Senha atualizada com sucesso.',
  Unauthenticated: 'Sessão expirada. Faça login novamente.',
  'Unauthenticated.': 'Sessão expirada. Faça login novamente.',
  'Invalid collaborator token.': 'Sessão de colaborador inválida. Faça login novamente.',
  'Collaborator access disabled.': 'O acesso deste colaborador está desativado.',
}

export function mapPasswordChangeErrorMessage(message: string): string {
  return LEGACY_PASSWORD_ERROR_MESSAGES[message] ?? message
}

export function formatPasswordChangeValidationErrors(
  errors: Record<string, string[]>
): string {
  const messages = Object.values(errors)
    .flat()
    .map((item) => mapPasswordChangeErrorMessage(item))
  return messages.length > 0 ? messages.join(' ') : ''
}
